// extracted by mini-css-extract-plugin
export var base = "ToggleInputGroup-module--base--a6cae";
export var checkbox = "ToggleInputGroup-module--checkbox--076e9";
export var container = "ToggleInputGroup-module--container--94240";
export var disabled = "ToggleInputGroup-module--disabled--d7874";
export var divider = "ToggleInputGroup-module--divider--0eea9";
export var item = "ToggleInputGroup-module--item--c852f";
export var min = "ToggleInputGroup-module--min--7979c";
export var radio = "ToggleInputGroup-module--radio--7999f";